import styled from 'styled-components'

export default styled.div`
  position: relative;
  height: 100%;

  .alterations-icon {
    position: absolute;
    top: 20px;
    left: 20px;

    width: 40px;
    height: 40px;
    background-color: ${ ({theme}) => theme.colors.white};
    border-radius: 50%;
    cursor: pointer;

    img {
      width: 40px;
      height: 40px;
    }
  }
`